import useUIBp from "../../../../Hooks/useUIBoilerplate";
import BasicRow from "../../../UI/BasicLayout/Components/BasicRow";
import {
  connectionColumnID,
  devicesColumnID,
  groupColumnID,
  lastBackupColumnID,
  lastSentColumnID,
  nameColumnID,
  sizeColumnID,
  stateColumnID,
  uploadColumnID,
  versionColumnID,
} from "../../Dialogs/ToggleReportColumns/Components/ColumnsList/ColumnsList";
import Bandwidth from "./Components/Bandwidth";
import Device from "./Components/Device";
import Group from "./Components/Group";
import LastBackup from "./Components/LastBackup";
import LastChanges from "./Components/LastChanges";
import Online from "./Components/Online";
import Size from "./Components/Size";
import Status from "./Components/Status";
import Username from "./Components/Username";
import Version from "./Components/Version";

// const rowData = {
//   id: "", // for select
//   disabled, // for select
//   elements: [{ xs, content: "ELEMENT" }],
// };
const fontSize = 13;

const ReportRow = (props) => {
  const { auth, settings, UI } = useUIBp();
  const { mid } = props;
  const showNameColumn = UI[nameColumnID] ?? true;
  const showDeviceColumn = UI[devicesColumnID] ?? true;
  const showGroupColumn = UI[groupColumnID] ?? true;
  const showSizeColumn = UI[sizeColumnID] ?? true;
  const showLastBackupColumn = UI[lastBackupColumnID] ?? true;
  const showLastSentColumn = UI[lastSentColumnID] ?? true;
  const showVersionColumn = UI[versionColumnID] ?? true;
  const showUploadColumn = UI[uploadColumnID] ?? true;
  const showConnectionColumn = UI[connectionColumnID] ?? true;
  const showStateColumn = UI[stateColumnID] ?? true;

  let data = {
    id: auth.admin === 1 ? mid : undefined,
    disabled: auth.admin === 1 ? !mid : undefined,
    elements: [],
  };

  if (showNameColumn) data.elements.push({ content: <Username {...props} {...{ fontSize }} />, size: "grow", minWidth: 0 });
  if (showDeviceColumn) data.elements.push({ content: <Device {...props} {...{ fontSize }} />, size: "grow", minWidth: 0 });
  if (showGroupColumn) data.elements.push({ content: <Group {...props} {...{ fontSize }} />, size: "grow", minWidth: 0 });
  if (showSizeColumn) data.elements.push({ content: <Size {...props} {...{ fontSize }} />, size: 1 });
  if (showLastBackupColumn)
    data.elements.push({
      content: <LastBackup {...props} {...{ fontSize, settings }} />,
      size: 1.5,
    });
  if (showLastSentColumn)
    data.elements.push({
      content: <LastChanges {...props} {...{ fontSize, settings }} />,
      size: 1.5,
    });
  if (showUploadColumn)
    data.elements.push({
      content: <Bandwidth {...props} {...{ fontSize }} />,
      justify: "center",
      size: 0.8,
    });
  if (showVersionColumn)
    data.elements.push({
      content: <Version {...props} {...{ fontSize }} />,
      justify: "center",
      size: 0.9,
    });
  if (showConnectionColumn)
    data.elements.push({
      content: <Online {...props} {...{ fontSize, settings }} />,
      justify: "center",
      size: 0.8,
    });
  if (showStateColumn)
    data.elements.push({
      content: <Status {...props} {...{ fontSize, settings }} />,
      justify: "center",
      size: 0.8,
    });

  return <BasicRow {...data} />;
};

export default ReportRow;
